export default "__VITE_ASSET__CGjgYVGC__"